import request from '@/utils/request'

// 查询对话节点列表
export function listDialogueNode(query) {
  return request({
    url: '/dialogue-node/list',
    method: 'get',
    params: query
  })
}

// 获取对话节点树
export function getDialogueTree(characterId) {
  return request({
    url: `/dialogue-node/tree/${characterId}`,
    method: 'get'
  })
}

// 获取对话节点详情
export function getDialogueNode(nodeId) {
  return request({
    url: `/dialogue-node/${nodeId}`,
    method: 'get'
  })
}

// 新增对话节点
export function addDialogueNode(data) {
  return request({
    url: '/dialogue-node',
    method: 'post',
    data: data
  })
}

// 修改对话节点
export function updateDialogueNode(data) {
  return request({
    url: '/dialogue-node',
    method: 'put',
    data: data
  })
}

// 删除对话节点
export function delDialogueNode(nodeId) {
  return request({
    url: `/dialogue-node/${nodeId}`,
    method: 'delete'
  })
}

// 批量删除对话节点
export function batchDeleteDialogueNode(nodeIds) {
  return request({
    url: '/dialogue-node/batch',
    method: 'delete',
    data: nodeIds
  })
}

// 复制对话节点
export function copyDialogueNode(nodeId) {
  return request({
    url: `/dialogue-node/copy/${nodeId}`,
    method: 'post'
  })
}

// 移动对话节点
export function moveDialogueNode(data) {
  return request({
    url: '/dialogue-node/move',
    method: 'put',
    data: data
  })
}

// 更新节点排序
export function updateNodeOrder(data) {
  return request({
    url: '/dialogue-node/order',
    method: 'put',
    data: data
  })
}

// 搜索对话节点
export function searchDialogueNodes(query) {
  return request({
    url: '/dialogue-node/search',
    method: 'get',
    params: query
  })
}